import mobile from  './mobile.svg';
import web from './web.svg';
import ecommerce from './ecommerce.svg';
import hosting from './hosting.svg';
import angular from './angular.svg';
import drupal from './drupal.svg';
import java from './java.svg';
import joomla from './joomla.svg';
import magento from './magento.svg';
import php from './php.svg';
import react from './react.svg';
import apple from './apple.svg';
import vue from './vuejs.svg';
import android from './android.svg';
import node from './node.svg';
import wordpress from './wordpress.svg';
import cpanel from './cpanel.svg';
import digitalOcean from './digital-ocean.svg';
import openCart from './opencart.svg';
import laravel from './laravel.svg';
import idea from './idea.svg';
import solution from './solution.svg';
import ux from './ux.svg';

export {
    web,
    mobile,
    ecommerce,
    hosting,
    angular,
    drupal,
    java,
    joomla,
    magento,
    php,
    react,
    apple,
    vue,
    android,
    node,
    wordpress,
    cpanel,
    digitalOcean,
    openCart,
    laravel,
    idea,
    solution,
    ux
}


// WEBPACK FOOTER //
// ./src/assets/images/services/index.js